<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="app-select-wrapper" @keyup.esc="outClick" v-click-outside="outClick">
        <input
          type="search"
          class="app-select-search form-control"
          @focus="open"
          @click="open"
          @input="search"
          :placeholder="placeholder"
          @keyup.down="onArrowDown"
          @keyup.up="onArrowUp"
          @keyup.enter="onEnter"
        />
        <div v-if="isResultListActive" class="app-select-result" :style="listHeightStyle" @scroll="pageLoader" ref="list">
          <div class="app-select-item" @click.stop.prevent="select(searchQuery)" v-if="searchQuery && proposeNew">
            <b>{{ searchQuery }}</b> (create new)
          </div>
          <div
            class="app-select-item"
            v-for="(item, i) in innerItems"
            :key="item.id"
            :class="{ 'is-active': i === itemPositionCounter }"
            ref="scrollItems"
            @click="select(item, i)"
            @mouseover="itemPositionCounter = i"
          >
            <slot :item="item"></slot>
          </div>
          <div class="app-select-item text-muted empty-results" v-if="!proposeNew && !innerItems.length">
            not found
          </div>
          <div ref="bottom" class="list-bottom"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppSelect',
  props: {
    items: Array,
    placeholder: String,
    proposeNew: {
      type: Boolean,
      default: true
    },
    removeSelected: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    value: '',
    searchQuery: '',
    searchActive: false,
    itemsStore: {},
    itemsStoreList: [],
    pixelsToScrollEnd: 10,
    itemPositionCounter: -1,
    listHeightStyle: ''
  }),
  computed: {
    isResultListActive() {
      return this.searchActive // && (this.searchQuery.length || this.innerItems.length)
    },
    innerItems() {
      return this.itemsStoreList.map((id) => this.itemsStore[id])
    }
  },
  methods: {
    select(item, i) {
      this.searchActive = false
      if (this.removeSelected) {
        this.itemsStoreList.splice(i, 1)
      }
      this.$emit('select', item)
    },
    search(e) {
      if (e) this.searchQuery = e.target.value || ''
      this.itemsStore = {} // on new search reset previous results
      this.itemsStoreList = []
      this.itemPositionCounter = -1
      this.$emit('search', this.searchQuery)
    },
    outClick() {
      this.searchActive = false
      this.itemPositionCounter = -1
      this.itemsStore = {} // on new search reset previous results
      this.itemsStoreList = []
      this.itemPositionCounter = -1
    },
    pageLoader(e) {
      const el = e.target
      // if less then pixelsToScrollEnd left load next page
      if (el.scrollHeight - el.scrollTop - el.clientHeight < this.pixelsToScrollEnd) {
        this.$emit('nextPage', this.searchQuery)
      }
    },
    open() {
      this.search('')
      this.searchActive = true
    },
    onArrowDown(e) {
      if (this.itemPositionCounter < this.itemsStoreList.length - 1) {
        this.itemPositionCounter = this.itemPositionCounter + 1
        this.$refs.scrollItems[this.itemPositionCounter].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        })
      }
    },
    onArrowUp() {
      if (this.itemPositionCounter > 0) {
        this.itemPositionCounter = this.itemPositionCounter - 1
        this.$refs.scrollItems[this.itemPositionCounter].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start'
        })
      }
    },
    onEnter() {
      if (this.itemPositionCounter >= 0) {
        const itemId = this.itemsStoreList[this.itemPositionCounter]
        const itemObj = this.itemsStore[itemId]
        this.$emit('select', itemObj)
        this.itemPositionCounter = -1
      }
    },
    onBottomViewportCross(entries) {
      if (entries[0]) {
        const heightDiff = window.innerHeight - entries[0].boundingClientRect.bottom
        const list = entries[0].target.parentElement
        if (heightDiff < 0) {
          const listRect = list.getBoundingClientRect()
          list.style.height = `${listRect.height + window.innerHeight - listRect.bottom - 3}px`
        } else {
          // turn off height adjust
          list.style.height = ''
        }
      }
    }
  },
  mounted() {
    this.search() // empty search for init items
  },
  watch: {
    items(newItems) {
      // infinity results implementation
      for (let item of newItems) {
        if (!Object.hasOwn(this.itemsStore, item.id)) {
          this.itemsStore[item.id] = item
          this.itemsStoreList.push(item.id)
        }
      }
    },
    isResultListActive: {
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            const observer = new IntersectionObserver(this.onBottomViewportCross, { threshold: 1 })
            observer.observe(this.$refs.bottom)
          })
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-select-wrapper {
  position: relative;
}

.app-select-result {
  display: flex;
  flex-direction: column;
  position: absolute;
  border: 1px solid #aaa;
  top: 34px;
  width: 100%;
  background: #fff;
  max-height: 30vh;
  overflow-y: scroll;
  z-index: 999;
}

.app-select-item {
  cursor: pointer;
  padding: 0.375rem 0.75rem;
  background: #fff;
}

.is-active {
  background-color: #4680ff;
  color: white;
}

.empty-results:hover {
  color: inherit;
  background: inherit;
}

.list-bottom {
  height: 1px;
}
</style>
